// Public i18n resources (WP-C, 2026-10-09).
//
// Pure data module (no runtime deps) so scripts/i18n-check.mjs can load it.
//
// Bundle split:
//   - en + es: eager, imported here by NAMED export so webpack drops the unused
//     fr/pt exports of each ns file from the main chunk.
//   - fr + pt: lazy. Production loads ./lang/{fr,pt}.json (generated from the
//     same ns files by `npm run i18n:gen`; `npm run check` fails if stale).
//   - careers, legal: separate i18next namespaces registered by their lazy routes.
//   - admin: merged into `translation.admin` by src/AdminApp.tsx (admin chunk).
//
// Adding a public namespace = add it to PUBLIC_TREE *and* to both trees below.
import { en as headerEn, es as headerEs } from "./ns/header";
import { en as heroEn, es as heroEs } from "./ns/hero";
import { en as proofEn, es as proofEs } from "./ns/proof";
import { en as servicesEn, es as servicesEs } from "./ns/services";
import { en as teamEn, es as teamEs } from "./ns/team";
import { en as approachEn, es as approachEs } from "./ns/approach";
import { en as clientsEn, es as clientsEs } from "./ns/clients";
import { en as faqEn, es as faqEs } from "./ns/faq";
import { en as contactEn, es as contactEs } from "./ns/contact";
import { en as footerEn, es as footerEs } from "./ns/footer";
import { en as metaEn, es as metaEs } from "./ns/meta";

export const LANGUAGES = ["en", "es", "fr", "pt"] as const;
export type Language = (typeof LANGUAGES)[number];
export const LAZY_LANGUAGES = ["fr", "pt"] as const;
export type LazyLanguage = (typeof LAZY_LANGUAGES)[number];

/**
 * Runtime top-level key (as used in t("key.…")) -> ns file under ./ns.
 * `testimonials` lives in ns/clients.ts and `quoteForm` in ns/contact.ts
 * (the admin CRM reads quoteForm.option*). Used by the scripts to build fr/pt.
 */
export const PUBLIC_TREE = {
  header: "header",
  hero: "hero",
  proof: "proof",
  services: "services",
  team: "team",
  approach: "approach",
  testimonials: "clients",
  faq: "faq",
  quoteForm: "contact",
  footer: "footer",
  meta: "meta",
} as const;

/** Namespaces registered by lazy chunks (not in the main bundle). */
export const LAZY_NAMESPACES = ["careers", "legal", "admin"] as const;

export const resources = {
  en: {
    translation: {
      header: headerEn,
      hero: heroEn,
      proof: proofEn,
      services: servicesEn,
      team: teamEn,
      approach: approachEn,
      testimonials: clientsEn,
      faq: faqEn,
      quoteForm: contactEn,
      footer: footerEn,
      meta: metaEn,
    },
  },
  es: {
    translation: {
      header: headerEs,
      hero: heroEs,
      proof: proofEs,
      services: servicesEs,
      team: teamEs,
      approach: approachEs,
      testimonials: clientsEs,
      faq: faqEs,
      quoteForm: contactEs,
      footer: footerEs,
      meta: metaEs,
    },
  },
};
